import { __ON_PREMISE__ } from 'index';

const baseURI = `${import.meta.env.VITE_API_URL}api/`;
const AI_GARMENT_PLATFORM_BASE_URL = `${import.meta.env.VITE_AIGARMENT_PLATFORM_BASE_URL}`;
const isOnPremise = import.meta.env.VITE_ON_PREMISE === 'true';
let BASE_URL = baseURI;
let DEVICES_BASE_URL = import.meta.env.VITE_DEVICES_BASE_URL;
let SOCKET_URL = import.meta.env.VITE_SOCKET_URL;
let COMPANY = import.meta.env.VITE_CURRENT_COMPANY;
let DISPLAYS_URL = import.meta.env.VITE_DISPLAYS_URL;

export const COMPANY_KEY = 'garment-devtools/company';
const BASE_URL_KEY = 'garment-devtools/baseURL';
const DEVICES_BASE_URL_KEY = 'garment-devtools/devicesBaseURL';
const SOCKET_URL_KEY = 'garment-devtools/socketUrl';
const DISPLAYS_KEY = 'garment-devtools/displays';

export const DEV_TOOLS_SET_URL = (
    url,
    devicesBaseURL,
    socketURL,
    displaysURL,
) => {
    if (
        import.meta.env.MODE === 'development' ||
        import.meta.env.VITE_SHOW_DEV_TOOL
    ) {
        localStorage.setItem(BASE_URL_KEY, url);
        BASE_URL = url;

        localStorage.setItem(DEVICES_BASE_URL_KEY, devicesBaseURL);
        DEVICES_BASE_URL = devicesBaseURL;

        localStorage.setItem(SOCKET_URL_KEY, socketURL);
        SOCKET_URL = socketURL;

        localStorage.setItem(DISPLAYS_KEY, displaysURL);
        DISPLAYS_URL = displaysURL;
    }
};

export const DEV_TOOLS_SET_COMPANY = (company) => {
    console.log('setting company beginning');
    if (
        import.meta.env.MODE === 'development' ||
        import.meta.env.VITE_SHOW_DEV_TOOL
    ) {
        console.log('setting company passed if condition');
        localStorage.setItem(COMPANY_KEY, company);
        COMPANY = company;
        console.log('set company');
    }
};

if (
    import.meta.env.MODE === 'development' ||
    import.meta.env.VITE_SHOW_DEV_TOOL
) {
    BASE_URL = localStorage.getItem(BASE_URL_KEY) ?? baseURI;
    localStorage.setItem(BASE_URL_KEY, BASE_URL);

    DEVICES_BASE_URL =
        localStorage.getItem(DEVICES_BASE_URL_KEY) ?? DEVICES_BASE_URL;
    localStorage.setItem(DEVICES_BASE_URL_KEY, DEVICES_BASE_URL);

    SOCKET_URL = localStorage.getItem(SOCKET_URL_KEY) ?? SOCKET_URL;
    localStorage.setItem(SOCKET_URL_KEY, SOCKET_URL);

    DISPLAYS_URL = localStorage.getItem(DISPLAYS_KEY) ?? DISPLAYS_URL;
    localStorage.setItem(DISPLAYS_KEY, DISPLAYS_URL);

    COMPANY = localStorage.getItem(COMPANY_KEY) ?? COMPANY;
    localStorage.setItem(COMPANY_KEY, COMPANY);
}

export const GET_BASE_URL = () => BASE_URL;

export const GET_DEVICES_BASE_URL = () => DEVICES_BASE_URL;

export const GET_SOCKET_URL = () => SOCKET_URL;

export const GET_DISPLAYS_URL = () => DISPLAYS_URL;
export const GET_AI_GARMENT_PLATFORM_BASE_URL = () => isOnPremise ? '/copilot/' : AI_GARMENT_PLATFORM_BASE_URL

export const GET_COMPANY = () =>
    __ON_PREMISE__ ? localStorage.getItem(COMPANY_KEY) : COMPANY;
